module.exports = __webpack_public_path__ + "static/media/goods_title_en@3x.235112a6.png";